import { Loader2 } from 'lucide-react';

export function RouteFallback() {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-[#050505]">
      <Loader2 className="w-10 h-10 animate-spin text-emerald-500" />
    </div>
  );
}
